import React from 'react';
import { Package, Gift } from 'lucide-react';
import { Section } from './ui/Section';
export function ValueStackSection() {
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto" data-id="element-209">
      <div className="text-center mb-12" data-id="element-210">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-100" data-id="element-211">
          Stack de Valor Total
        </h2>
      </div>

      <div className="border border-[#b8860b]/30 bg-[#0a0a0a] rounded-sm overflow-hidden" data-id="element-212">
        <div className="p-6 md:p-8 space-y-6" data-id="element-213">
          {/* Main Product */}
          <div className="flex items-center justify-between pb-6 border-b border-gray-800" data-id="element-214">
            <div className="flex items-center space-x-4" data-id="element-215">
              <div className="p-2 bg-[#111827] border border-gray-800 rounded-sm" data-id="element-216">
                <Package className="w-5 h-5 text-gray-400" data-id="element-217" />
              </div>
              <span className="font-sans text-lg text-gray-200" data-id="element-218">
                Producto Principal
              </span>
            </div>
            <span className="font-mono text-gray-400" data-id="element-219">$97 USD</span>
          </div>

          {/* Bonuses */}
          <div className="space-y-4 pb-6 border-b border-gray-800" data-id="element-220">
            <div className="flex items-center justify-between" data-id="element-221">
              <div className="flex items-center space-x-4" data-id="element-222">
                <div className="p-2 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-sm" data-id="element-223">
                  <Gift className="w-5 h-5 text-[#d4a853]" data-id="element-224" />
                </div>
                <span className="font-sans text-gray-300" data-id="element-225">
                  Bono #1 — El Mapa de 30 Minutos
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-226">
                <span className="font-mono text-gray-500 line-through decoration-red-500/50" data-id="element-227">
                  $27 USD
                </span>
                <span className="font-mono font-bold text-[#d4a853] text-sm tracking-widest" data-id="element-228">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-229">
              <div className="flex items-center space-x-4" data-id="element-230">
                <div className="p-2 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-sm" data-id="element-231">
                  <Gift className="w-5 h-5 text-[#d4a853]" data-id="element-232" />
                </div>
                <span className="font-sans text-gray-300" data-id="element-233">
                  Bono #2 — Biblioteca de Respuestas Blindadas
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-234">
                <span className="font-mono text-gray-500 line-through decoration-red-500/50" data-id="element-235">
                  $37 USD
                </span>
                <span className="font-mono font-bold text-[#d4a853] text-sm tracking-widest" data-id="element-236">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-237">
              <div className="flex items-center space-x-4" data-id="element-238">
                <div className="p-2 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-sm" data-id="element-239">
                  <Gift className="w-5 h-5 text-[#d4a853]" data-id="element-240" />
                </div>
                <span className="font-sans text-gray-300" data-id="element-241">
                  Bono #3 — El Kit Anti-Caos
                </span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-242">
                <span className="font-mono text-gray-500 line-through decoration-red-500/50" data-id="element-243">
                  $27 USD
                </span>
                <span className="font-mono font-bold text-[#d4a853] text-sm tracking-widest" data-id="element-244">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          {/* Total Value */}
          <div className="flex items-center justify-between pt-2" data-id="element-245">
            <span className="font-mono font-bold tracking-widest uppercase text-gray-400" data-id="element-246">
              Valor Total
            </span>
            <span className="font-mono font-bold text-xl text-gray-400 line-through decoration-red-500/50 decoration-2" data-id="element-247">
              $188 USD
            </span>
          </div>
        </div>

        {/* Today's Price */}
        <div className="bg-[#d4a853]/10 border-t border-[#d4a853]/30 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between" data-id="element-248">
          <span className="font-serif text-2xl md:text-3xl font-bold text-[#f0c674] mb-2 md:mb-0" data-id="element-249">
            HOY PAGÁS
          </span>
          <div className="flex items-center space-x-4" data-id="element-250">
            <span className="font-mono text-2xl md:text-3xl text-gray-500 line-through decoration-red-500/60 decoration-2" data-id="element-251">
              $47 USD
            </span>
            <span className="font-mono text-4xl md:text-5xl font-bold text-[#f0c674] text-glow" data-id="element-252">
              $6 USD
            </span>
          </div>
        </div>
      </div>
    </Section>;
}